/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Clusterer } from '@react-google-maps/marker-clusterer';
import { Providers } from '@tripian/model';
import GMarkerProviderStorageBase from './Base/GMarkerProviderStorageBase/GMarkerProviderStorageBase';

interface IGMarkerProviderStorage {
  providerStorage: Providers.RadicalStorage.StorageItem;
  animation?: 1 | 2;
  clusterer?: Clusterer;
  markerStorageClicked: (storage: Providers.RadicalStorage.StorageItem) => void;
  isFocused?: boolean;
}

const GMarkerProviderStorage: React.FC<IGMarkerProviderStorage> = ({ providerStorage, animation, clusterer, markerStorageClicked, isFocused = false }) => (
  <GMarkerProviderStorageBase
    coordinate={{ lat: Number(providerStorage.coordinate.lat), lng: Number(providerStorage.coordinate.lng) }}
    animation={animation}
    clusterer={clusterer}
    markerStorageClicked={() => markerStorageClicked(providerStorage)}
    isFocused={isFocused}
  />
);

export default GMarkerProviderStorage;
